import styled from "styled-components";
import tw from "twin.macro";
import GradientButton from "../../../../components/GradientButton";

const SectionEight = styled.section`
  ${tw`relative flex flex-col`}
  z-index: 1;
  min-height: 100vh;
  background: #fff;

  @media (max-width: 767px) {
    min-height: 100vh;
  }
`;

const SectionEightIntro = styled.div`
  background: linear-gradient(90deg, #d8e7e5 0 50%, #f5ece6 50% 100%);

  @media (max-width: 767px) {
    background: #fff;
  }
`;

const SectionEightIntroInner = styled.div`
  ${tw`mx-auto grid gap-10`}
  max-width: 1440px;
  padding: 2.35rem var(--app-content-gutter) 2.15rem;

  @media (min-width: 1024px) {
    grid-template-columns: 1.05fr 0.95fr;
    column-gap: 0;
    align-items: center;
  }

  @media (max-width: 1023px) {
    background: linear-gradient(180deg, #d8e7e5 0 50%, #f5ece6 50% 100%);
    margin: 0;
    max-width: none;
  }

  @media (max-width: 767px) {
    display: block;
    background: #fff;
    padding: 3.65rem 42px 0;
  }
`;

const SectionEightMainTitle = styled.h3`
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 28px;
  line-height: 1.08;
  font-weight: 400;
  color: #437672;
  text-transform: uppercase;

  strong {
    font-weight: 700;
  }

  @media (max-width: 767px) {
    font-size: 20px;
    line-height: 1.12;
  }
`;

const SectionEightSideText = styled.p`
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 1.28;
  font-weight: 400;
  color: #437672;
  text-transform: uppercase;

  strong {
    font-weight: 700;
  }

  @media (max-width: 767px) {
    margin-top: 2.6rem;
    font-size: 12px;
    line-height: 1.25;
  }
`;

const SectionEightContent = styled.div`
  ${tw`mx-auto flex flex-col justify-center`}
  flex: 1;
  width: 100%;
  max-width: 1440px;
  padding: 2.35rem var(--app-content-gutter) 3rem;

  @media (max-width: 1023px) {
    padding-top: 2.5rem;
    padding-bottom: 4rem;
  }

  @media (max-width: 767px) {
    flex: none;
    justify-content: flex-start;
    padding: 3.7rem 42px 3.35rem;
  }
`;

const SectionEightStats = styled.div`
  ${tw`grid gap-8`}

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 2rem;
    align-items: start;
  }

  @media (max-width: 767px) {
    gap: 2.55rem;
  }
`;

const SectionEightStat = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SectionEightStatImage = styled.label`
  width: 287px;
  font-family: "Montserrat", sans-serif;
  font-size: 96px;
  height: auto;
  display: block;
  font-weight: 700;
  color: #4f8884;
  margin: 0 auto;

  @media (max-width: 767px) {
    width: auto;
    font-size: 78px;
    line-height: 0.92;
  }
`;

const SectionEightStatLabel = styled.div`
  margin-top: 1rem;
  min-height: 54px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  line-height: 1.1;
  font-weight: 700;
  color: #4d4b4b;
  text-transform: uppercase;
  white-space: normal;
  text-align: center;

  @media (max-width: 767px) {
    margin-top: 0.35rem;
    min-height: 0;
    font-size: 18px;
    line-height: 1.12;
  }
`;

const SectionEightFooter = styled.div`
  ${tw`grid gap-6 items-center`}
  margin-top: 2.1rem;

  @media (min-width: 1024px) {
    display: flex;
    justify-content: center;
  }

  @media (max-width: 767px) {
    margin-top: 3.45rem;
    gap: 1.65rem;
  }
`;

const SectionEightFooterText = styled.p`
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  line-height: 1.1;
  font-weight: 500;
  color: #4d4b4b;
  text-transform: uppercase;
  text-align: center;

  @media (max-width: 767px) {
    font-size: 17px;
    line-height: 1.22;
    max-width: 330px;
    margin: 0 auto;
  }
`;

const SectionEightCta = styled(GradientButton)`
  max-width: 100%;
  padding: 12px 30px;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 1.1;
  font-weight: 500;

  @media (max-width: 767px) {
    min-width: 0;
    width: 100%;
  }
`;

export {
  SectionEight,
  SectionEightIntro,
  SectionEightIntroInner,
  SectionEightMainTitle,
  SectionEightSideText,
  SectionEightContent,
  SectionEightStats,
  SectionEightStat,
  SectionEightStatImage,
  SectionEightStatLabel,
  SectionEightFooter,
  SectionEightFooterText,
  SectionEightCta,
};
